import type Dialog from '@naturehouse/design-system/components/molecules/dialog/Dialog';
import SearchResultsExtraCostsDialogRenderer from './SearchResultsExtraCostsDialogRenderer';

export default class SearchResultsExtraCostsDialogHandler {
    static #instance: SearchResultsExtraCostsDialogHandler | null = null;

    readonly #form: HTMLFormElement | null = null;

    readonly #dialog: Dialog | null = null;

    readonly #searchResultsExtraCostsDialogRenderer =
        SearchResultsExtraCostsDialogRenderer.getInstance();

    #dialogHouseId: string | null = null;

    #dialogToggleButtons: HTMLElement[] = [];

    private constructor() {
        this.#form = document.getElementById('search-form') as HTMLFormElement;
        this.#dialog = document.querySelector('[data-role="extra-costs-dialog"]');
    }

    public static getInstance(): SearchResultsExtraCostsDialogHandler {
        if (SearchResultsExtraCostsDialogHandler.#instance === null) {
            SearchResultsExtraCostsDialogHandler.#instance =
                new SearchResultsExtraCostsDialogHandler();
        }
        return this.#instance!;
    }

    public static destroyInstance(): void {
        this.#instance = null;
    }

    public readonly setEventListeners = (): void => {
        if (!this.#form || !this.#dialog) {
            return;
        }

        this.#dialogToggleButtons = Array.from(
            document.querySelectorAll('[data-role="extra-costs-dialog-toggle"]')
        );
        for (const button of this.#dialogToggleButtons) {
            button.addEventListener('click', this.#handleToggleDialog);
        }
    };

    public readonly removeEventListeners = (): void => {
        if (!this.#dialogToggleButtons.length) {
            return;
        }

        for (const button of this.#dialogToggleButtons) {
            button.removeEventListener('click', this.#handleToggleDialog);
        }
    };

    readonly #handleToggleDialog = async (event: Event): Promise<void> => {
        const currentTarget = event.currentTarget as HTMLButtonElement;
        const clickedHouseId = currentTarget.dataset.targetHouseId;

        if (!clickedHouseId) {
            return;
        }

        if (clickedHouseId === this.#dialogHouseId) {
            this.#dialog!.showModal();
            return;
        }

        this.#dialogHouseId = clickedHouseId;
        const dialogContent = await this.#searchResultsExtraCostsDialogRenderer.render(
            currentTarget,
            clickedHouseId
        );

        if (!dialogContent) {
            this.#dialogHouseId = null;
            this.#dialog!.content = '';
            return;
        }

        this.#dialog!.content = dialogContent;
        this.#dialog!.showModal();
    };
}
